const MONTH_NAMES = {
    0: {
        long: 'January',
        short: 'Jan',
    },
    1: {
        long: 'February',
        short: 'Feb',
    },
    2: {
        long: 'March',
        short: 'Mar',
    },
    3: {
        long: 'April',
        short: 'Apr',
    },
    4: {
        long: 'May',
        short: 'May',
    },
    5: {
        long: 'June',
        short: 'Jun',
    },
    6: {
        long: 'July',
        short: 'Jul',
    },
    7: {
        long: 'August',
        short: 'Aug',
    },
    8: {
        long: 'September',
        short: 'Sep',
    },
    9: {
        long: 'October',
        short: 'Oct',
    },
    10: {
        long: 'November',
        short: 'Nov',
    },
    11: {
        long: 'December',
        short: 'Dec',
    },
};

export function formatDateShortMonth(date) {

    return `${MONTH_NAMES[date.getMonth()].short} ${date.getDate()}, ${date.getFullYear()}`;

};
